import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface CollapsedGroupsState {
  collapsedGroups: string[];
}

const initialState: CollapsedGroupsState = {
  collapsedGroups: []
};

const collapsedGroupsSlice = createSlice({
  name: 'collapsedGroups',
  initialState,
  reducers: {
    toggleCollapsedGroup( state, action: PayloadAction<string> ) {
      const groupKey = action.payload;
      const index = state.collapsedGroups.indexOf( groupKey );
      if ( index >= 0 ) {
        state.collapsedGroups.splice( index, 1 );
      } else {
        state.collapsedGroups.push( groupKey );
      }
    },
    setCollapsedGroups( state, action: PayloadAction<string[]> ) {
      state.collapsedGroups = action.payload;
    }
  }
});

export const { toggleCollapsedGroup, setCollapsedGroups } = collapsedGroupsSlice.actions;
export default collapsedGroupsSlice.reducer;


let lastArrayRef: string[] | null = null;
let lastSetRef: Set<string> | null = null;

export const selectCollapsedGroups = createSelector(
  [( state: RootState ) => state.spreadsheet.collapsedGroups.collapsedGroups],
  ( collapsedArray ) => {
    if ( collapsedArray !== lastArrayRef ) {
      lastArrayRef = collapsedArray;
      lastSetRef = new Set( collapsedArray );
    }
    return lastSetRef!;
  }
);